import { useLocation } from "react-router-dom";
import { useLoadSessionQuery } from "../features/mc-square-api/mc-square-api-slice";
import { UNKNOWN_USER } from "../constants/proptypes";

const PAGE_TITLES = {
  "/": "Dashboard",
  "/settings": "Settings",
  "/sync-logs": "Sync Logs",
  "/support": "Support",
  "/all-set": "All Set",
  "/estimated_marketing_reach": "Setup - Estimated Marketing Reach",
  "/audience": "Setup - Audience Selection",
  "/merge_field_mappings": "Setup - Field Mappings",
  "/sync": "Setup - Initial Sync",
  "/authenticate/mailchimp/create": "Setup - Create Mailchimp Account",
  "/authenticate/mailchimp/success": "Setup - Mailchimp Account Created",
};

const DEFAULT_PAGE_TITLE = "Mailchimp for Square";

const getPageTitle = (pathname, setupComplete) => {
  if (pathname === "/" && !setupComplete) return DEFAULT_PAGE_TITLE;

  const title = PAGE_TITLES[pathname];
  if (title) {
    return `${title} - ${DEFAULT_PAGE_TITLE}`;
  }

  return DEFAULT_PAGE_TITLE;
};

const usePageTitle = () => {
  const location = useLocation();
  const { data: squareUser = UNKNOWN_USER } = useLoadSessionQuery();

  return getPageTitle(location.pathname, squareUser.setupComplete);
};

export default usePageTitle;
